<template>
  <select
    :value="value"
    @change="updateValue"
    v-bind="$attrs"
    class="
      w-[18]
      border-gray-300
      rounded-md
      shadow-sm
      focus:outline-none focus:ring-cyan-500 focus:border-cyan-500
    "
  >
    <option
      v-for="option in options"
      :key="option"
      :value="option"
      :selected="option === value"
    >
      {{ option }}
    </option>
  </select>
</template>

<script>
export default {
  name: 'AppSelect',

  inheritAttrs: false,

  props: {
    value: [String, Number],

    options: {
      type: Array,
      required: true,
    },
  },

  methods: {
    updateValue(event) {
      this.$emit('input', event.target.value)
      this.$emit('selectChangeValue')
    },
  },
}
</script>
